module.exports = __webpack_public_path__ + "img/loginbg.3535f14f.jpg";